import type * as React from "react";
import { memo } from "react";

interface TracePartsIframeProps {
  url: string;
}

const TracePartsIframe: React.FC<TracePartsIframeProps> = ({ url }) => {
  return <iframe src={url} className="scha__pdp-iframe" id="cadIframe" scrolling="no" />;
};

export default memo(TracePartsIframe);
